import React from 'react'

function LocalesMercadoItem(props) {
  const openModal = () => {
    console.log('hello')
  }

  return (
    <div
      className='caja'
      id={props.localMercado.id}
      onClick={() => props.editLocal(props.localMercado)}
    >
      {props.localMercado.nombre}
    </div>
  )
}

export {LocalesMercadoItem}
